export default "skymp5-front/3515ee259d463b2686197113061e2cf5.png";